import {
  ASSUME_TENANT_HEADER,
  SUPPORT_MODE_HEADER,
  SUPPORT_TENANT_STORAGE_KEY,
} from '../../constants/http-headers.constants';

/**
 * Resolves support-mode headers for the current browser session.
 *
 * @returns Support-mode headers when an assumed tenant is active.
 */
export const resolveSupportModeHeaders = (): Record<string, string> => {
  if (typeof window === 'undefined') {
    return {};
  }

  const assumedTenantId = window.localStorage.getItem(
    SUPPORT_TENANT_STORAGE_KEY
  );

  if (!assumedTenantId || assumedTenantId.trim().length === 0) {
    return {};
  }

  return {
    [ASSUME_TENANT_HEADER]: assumedTenantId.trim(),
    [SUPPORT_MODE_HEADER]: 'true',
  };
};
